import { productSecurityProps } from '../Checkmarx/types';

export const testData: productSecurityProps = {
  runId: 'psp-8f3c2a',
  product: {
    name: 'Digital Hangar Dock',
    entityRef: 'system:default/digital-hangar-dock',
  },
  status: 'completed',
  repositories: [
    {
      name: 'dh-dock',
      sonarQube: {
        status: 'completed',
        projectKey: 'dh-dock',
        url: 'https://sonarqube.example/portfolio?id=dh-dock',
      },
      checkmarx: {
        status: 'completed',
        project: 'lhgdh/dh-dock',
      },
      pullRequestUrl: 'https://github.example/lhgdh/dh-dock/pull/123',
      reviewReport: 'reports/SECURITY_REVIEW_dh-dock.md',
    },
  ],
  productSecurityViews: {
    sonarQubePortfolio:
      'https://sonarqube.example/portfolio?id=digital-hangar-dock',
    checkmarxApplication: 'https://checkmarx.example/applications/abc123',
  },
  pendingApprovals: [],
  errors: [],
};
